export const setMettressSize = (size) => ({
  type: "SET_METTRESS_SIZE",
  payload: size,
});

export const setMettressDepth = (depth) => ({
  type: "SET_METTRESS_DEPTH",
  payload: depth,
});
